/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { Navigate, useLocation } from 'react-router-dom';
import authStore from '@stores/auth';
import documentStore from '@stores/document';
import Cookies from 'js-cookie';
import { storageKeys } from '@/constants';
import czFavicon from '@/assets/zd/czFavicon.png';

const ProtectedRoute = ({
  component,
  permissionKey,
  allowAccess,
  adminOnly,
  title,
}) => {
  const location = useLocation();
  const tenantCode = Cookies.get(storageKeys.tenantCode);
  const titleSuffix = title ? ` - ${title}` : '';
  useEffect(() => {
    // document.title = `${process.env.REACT_APP_WEBSITE_TITLE}${title ? ` - ${title}` : ''}`;
    document.title = `诚展实业${titleSuffix}`;
    documentStore.setPageTitle(title);
    documentStore.setFavicon(czFavicon);
  }, [title, authStore?.profile?.username]);

  if (!authStore.isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  const isAuthorized = adminOnly
    ? authStore.isAdmin
    : authStore.isAdmin || allowAccess || authStore.permissions?.includes(permissionKey);
  if (!isAuthorized) {
    return <Navigate to="/not-authorized" state={{ from: location }} />;
  }

  return component;
};

ProtectedRoute.propTypes = {
  component: PropTypes.node.isRequired,
  permissionKey: PropTypes.string,
  title: PropTypes.string,
  allowAccess: PropTypes.bool,
  adminOnly: PropTypes.bool,
};

ProtectedRoute.defaultProps = {
  permissionKey: '',
  title: '',
  allowAccess: false,
  adminOnly: false,
};

export default observer(ProtectedRoute);
